import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MapsLoaderService } from './maps-loader.service';
import { GoogleGeolocationResponseModel } from '../viewModels/google-geo-location-response-model';

@Injectable()
export class GeoLocationService {
  private geocoder: google.maps.Geocoder;

  constructor(
    private httpClient: HttpClient,
    private readonly mapsLoaderService: MapsLoaderService
  ) {
    this.mapsLoaderService.loadGoogleMapsAPIs().subscribe(() => {
      this.geocoder = new google.maps.Geocoder();
    });
  }

  public getPosition(): Observable<any> {
    return new Observable((observer) => {
      navigator.geolocation.getCurrentPosition(
        (pos) => observer.next(pos),
        (_err) => undefined,
        { enableHighAccuracy: true }
      );
    });
  }

  public getPositionFromGoogleGeolocationAPI(): Observable<GoogleGeolocationResponseModel> {
    const googleKey = this.mapsLoaderService.mapConfiguration.key;
    return this.httpClient.post<GoogleGeolocationResponseModel>(
      'https://www.googleapis.com/geolocation/v1/geolocate?key=' + googleKey,
      {}
    );
  }

  public getAddressFromCoordinates(lat: number, lng: number): Observable<google.maps.GeocoderResult[]> {
    return new Observable((observer) => {
      this.geocoder.geocode({
            location: {
              lat: lat,
              lng: lng,
            },
          },
          (results: google.maps.GeocoderResult[], _status: google.maps.GeocoderStatus) => {
            observer.next(results);
          }
      )
      .catch(() => undefined);
    });
  }
}
